/**
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
import { ClrResponsiveNavigationService } from "./clrResponsiveNavigationService";
export function clrResponsiveNavigationProvider(existing) {
    return existing || new ClrResponsiveNavigationService();
}
//# sourceMappingURL=clrResponsiveNavigationProvider.js.map


//////////////////
// WEBPACK FOOTER
// ./~/clarity-angular/layout/nav/clrResponsiveNavigationProvider.js
// module id = 300
// module chunks = 4